import { generateID } from "../../helpers/generateID";
import { StoreWallInterface } from "../../types/store";
import { partsProperties } from "../../../shared";

interface IncomingPropertiesInterface {
    width: number;
    isIndent: boolean;
    currentShelving: StoreWallInterface;
}

export const getNewSection = ({ width, isIndent, currentShelving }: IncomingPropertiesInterface) => {
    const newCurrentShelf = structuredClone(currentShelving);
    const height = currentShelving.height;
    //TODO: Замнить 4 - на параметр из админки (4 - это 2 ширины вертикальной направляющей)
    const offset = currentShelving.sections.reduce(
        (acc, curr) => acc + curr.width - partsProperties.railing.vertical.doubleWidth,
        0
    );
    if (offset + width < currentShelving.length) {
        const id = generateID();
        let leftRackHeight = isIndent ? 0 : height;
        if (currentShelving.sections.length !== 0) {
            //TODO если обновим TS то можно будет переписать на .at(-1)
            leftRackHeight = currentShelving.sections[currentShelving.sections.length - 1].isIndent
                ? height
                : currentShelving.sections[currentShelving.sections.length - 1].height;
        } else {
            newCurrentShelf.firstRackHeight = height;
        }
        newCurrentShelf.sections.push({
            items: [],
            width,
            leftRackHeight,
            height,
            offset,
            isIndent,
            id,
        });
    }
    return newCurrentShelf;
};
